import { FilterAttributeCodeDto } from '@checkfront/guest-experience-api-api-client-javascript-axios';

export const defaultMaxPriceRange: PriceRange = [0, 100];
export const defaultCurrency = 'EUR';
export const defaultRadius = 50;

export interface Filters {
  dates?: DateRange;
  location?: Location;
  price?: PriceRange;
  categories?: string[];
  misc?: string[];
  languages?: string[];
  sort?: Sort;
}
export type DateRange = [Date, Date];

export type PriceRange = [number, number];

export enum Sort {
  Distance = 'distance',
  HighestPrice = '-price',
  LowestPrice = 'price',
}

export interface Location {
  name: string;
  longitude: string;
  latitude: string;
  /** Radius in kilometers */
  radius: number;
}

export interface Language {
  id: string;
  text: string;
}

export type CategoryCode = FilterAttributeCodeDto.Tags | FilterAttributeCodeDto.Categories;

export const priceRangesAreEqual = (priceRange1?: PriceRange, priceRange2?: PriceRange) => {
  return priceRange1?.[0] === priceRange2?.[0] && priceRange1?.[1] === priceRange2?.[1];
};

export const locationsAreEqual = (location1?: Location, location2?: Location) =>
  (!location1 && !location2) ||
  (location1?.longitude === location2?.longitude &&
    location1?.latitude === location2?.latitude &&
    location1?.radius === location2?.radius);

export const dateRangesAreEqual = (dateRange1?: DateRange, dateRange2?: DateRange) => {
  return (
    dateRange1?.[0].getTime() === dateRange2?.[0].getTime() &&
    dateRange1?.[1].getTime() === dateRange2?.[1].getTime()
  );
};

export const datesAreEqual = (date1?: Date, date2?: Date) => date1?.getTime() === date2?.getTime();
